export const isListingFromMove = (listingId: string): boolean => {
  return listingId.startsWith('m')
}
